import * as C from './../containers/qr/constants';

const InitialState = {
    data: {}
};


export default (state = InitialState, action) => {
    if (action.type && C[action.type]) {
        return {
            state: action.type,
            data: action.data || {}
        };

    }
    return state;
}



// WEBPACK FOOTER //
// ./src/store/qr.reducer.js